module.exports = __webpack_public_path__ + "img/h4.3b6f38af.png";